// import img01 from "../assets/images/olympo36/img01.jpg"
import img01 from "../assets/images/olympo36/ESTANDAR/salon-de-pasajeros---acabado-techo.jpg"
// import img02 from "../assets/images/olympo36/img02.jpg"
import img02 from "../assets/images/olympo36/ESTANDAR/salon-pasajeros---acabado-lateral.jpg"
// import img03 from "../assets/images/olympo36/img03.jpg"
// import img04 from "../assets/images/olympo36/img04.jpg"
import img04 from "../assets/images/olympo36/ESTANDAR/salon-de-pasajeros---iluminacion.jpg"
import img05 from "../assets/images/olympo36/img05.jpg"
// import img06 from "../assets/images/olympo36/img06.jpg"
import img06 from "../assets/images/olympo36/ESTANDAR/cabina-de-conductor---cupula.jpg"
// import img07 from "../assets/images/olympo36/img07.jpg"
import img07 from "../assets/images/olympo36/ESTANDAR/cabina-conductor---mampara-divisoria.jpg"
// import img08 from "../assets/images/olympo36/img08.jpg"
import img08 from "../assets/images/olympo36/ESTANDAR/cabina-conductor---tablero-de-control.jpg"
import img09 from "../assets/images/olympo36/ESTANDAR/cabina-conductor---grada-de-ingreso.jpg"
// import img10 from "../assets/images/olympo36/img10.jpg"
import img10 from "../assets/images/olympo36/ESTANDAR/exterior-3.jpg"
// import img11 from "../assets/images/olympo36/img11.jpg"
import img11 from "../assets/images/olympo36/ESTANDAR/exterior-2.jpg"
// import img12 from "../assets/images/olympo36/img12.jpg"
// import img13 from "../assets/images/olympo36/img13.jpg"
import img13 from "../assets/images/olympo36/ESTANDAR/calefaccion.jpg"
// import img14 from "../assets/images/olympo36/img14.jpg"
import img14 from "../assets/images/olympo36/ESTANDAR/salon-pasajeros---asientos.jpg"
// import img15 from "../assets/images/olympo36/img15.jpg"
import img15 from "../assets/images/olympo36/OPCIONALES/aire-acondicionado.jpg"
// import img16 from "../assets/images/olympo36/img16.jpg"
import img16 from "../assets/images/olympo36/OPCIONALES/bano.jpg"
// import img17 from "../assets/images/olympo36/img17.jpg"
import img17 from "../assets/images/olympo36/ESTANDAR/conduccion---espejos-retrovisores.jpg"
// import img18 from "../assets/images/olympo36/img18.jpg"
import img18 from "../assets/images/olympo36/ESTANDAR/conduccion---accionamiento-puerta-servicio.jpg"
import img19 from "../assets/images/olympo36/ESTANDAR/conduccion---panel-de-control.jpg"
import img20 from "../assets/images/olympo36/ESTANDAR/exterior-1.jpg"
export const OlympoBlock1 = [
  {
    title: `ACABADO TECHO`,
    text: `<li>Decorado con material PVC DECORATIVO que es impermeable, de fácil limpieza, antinflamable y aislante térmico.</li>`,
    img: img01,
  },
  {
    title: `ACABADO LATERALES`,
    text: `<li>Decorado con material PVC DECORATIVO. </li>
    <li>Perfilado de marcos de ventanas con PVC DECORATIVO de brillo natural.</li>`,
    img: img02,
  },
  {
    title: `ACABADO DE PISO`,
    text: `<li>Cubierto en PVC FLEXIBLE DE ALTO TRÁNSITO resistente al desgaste, antinflamable y retardante.</li>
    <li> Opciones de colores.</li>`,
    img: img13,
  },
  {
    title: `ILUMINACIÓN`,
    text: `<li>Iluminación con tecnología LED, ubicados a cada lado de las paqueteras.</li>`,
    img: img04,
  },
  {
    title: `PAQUETERAS`,
    text: `<li>LIGERAS y elaboradas en poliuretano rigido de alta densidad.</li>
    <li> Fijadas en el techo estratégicamente para EVITAR VIBRACIONES.</li>
    <li> Luces de lectura individuales.</li>`,
    img: img05,
  },
  {
    title: `ASIENTOS`,
    text: `<li>Inyectados en espuma de poliuretano flexible, opciones de tapizado.</li>
    <li> Personalización de asientos de acuerdo a necesidades del cliente.</li>`,
    img: img14,
  },
  {
    title: `CALEFACCIÓN`,
    text: `<li>Concentradores de calor en base a serpentin y convección forzada con sopladores eléctricos silenciosos.</li>`,
    img: img13,
  },
]
export const OlympoBlock2 = [
  {
    title: `TABLERO DE CONTROL`,
    text: `<li>FACILITA LA OPERACIÓN del bus; diseño AERODINÁMICO y protección externa con poliuretano rígido.</li>`,
    img: img08,
  },
  {
    title: `GRADA DE INGRESO`,
    text: `<li>Con ILUMINACIÓN PROPIA y fabricado en fibra de vidrio.</li><li> Base estructural reforzado. </li>`,
    img: img09,
  },
  {
    title: `CÚPULA`,
    text: `<li>Gravado natural con lineas estilizadas decorativas y contornos definidos.</li>
    <li>  Iluminación con sistema LED.</li>`,
    img: img06,
  },
  {
    title: `MAMPARA DIVISORIA`,
    text: `<li>En armonia con los espacios que divide.</li><li>  Diseño panorámico.</li>`,
    img: img07,
  },
  
]
export const OlympoBlock3 = [
  {
    
    title:"ISO FRONTAL",
    text:'<li>AERODDINÁMICO Y ROBUSTO</li>',
    img:img20
  },
  {
    title: `ISO POSTERIOR`,
    text: `<li>ROBUSTO</li>`,
    img: img11,
  },
  {
    title: `FRONTAL`,
    text: `<li>Mascara, Parachoque y Trampilla Rebatible.</li>`,
    img: img10,
  },
  // {
  //   title: `BODEGAS`,
  //   text: ` Livianas, forradas en aluminio. Puertas de bodegas cuentan con mecanismo de seguridad de doble traba que garantizan un sello hermético.  `,
  //   img: img12,
  // },
]
export const OlympoBlock4 = [
 
  {
    title: `AIRE ACONDICIONADO`,
    text: `<li>Sistema que intercambia aire fresco del medio ambiente, purificado y climatizado a una determinada temperatura.</li><li> Garantiza comodidad y bienestar a los pasajeros.</li>`,
    img: img15,
  },
  {
    title: `BAÑO`,
    text: `<li>Mixto, urinario y taza. Con sistema automático de extracción de olores.</li>
     <li>Sistema de SANITIZACIÓN en base a Ozono.</li>`,
    img: img16,
  },
]
export const OlympoBlock5=[
  {
    title:"ESPEJOS RETROVISORES",
    text:`<li>Eléctricos y calefactor incluido.</li>
    <li> Mando selector que regulan el angulo de visión del conductor. </li>`,
    img:img17
  },
  {
    title:'ACCIONAMIENTO PUERTA SERVICIO',
    text:'<li>Control inalambrico para mayor seguridad de bloqueo/desbloqueo desde el exterior del bus.</li>',
    img:img18
  },
  {
    title:'PANEL DE CONTROL',
    text:'<li>Panel digital con tecnología de circuitos impresos con protección “Anti – solder” que garantizan la funcionalidad correcta del bus en los diferentes climas del Perú.</li>',
    img:img19
  }
]
export const OlympoBlock6=[
  
 
  
]